module.exports = __webpack_public_path__ + "static/media/Oxygen.65c251ce.otf";